import { render, staticRenderFns } from "./DeallistArchived.vue?vue&type=template&id=50ef228e&scoped=true"
import script from "./DeallistArchived.vue?vue&type=script&lang=js"
export * from "./DeallistArchived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ef228e",
  null
  
)

export default component.exports